import { defineStore } from 'pinia';
import { notify } from 'notiwind';

export const useCompanionPassStore = defineStore('companionpass', {
    state: () => ({
        passEnabled: false,
        fiveTwentyFour: false,
        fiveTwentyFourModal: false,
        canDismiss524Alert: false,
        beforeStartDate: false,
        completeSteps: [],
        stepsContent: [],
        steps: [
            {
                id: 1,
                num: '01',
                title: 'Open 1st Southwest Credit Card',
                short_content:
                    'Your first step in earning your Companion Pass will be to <strong>open a Southwest Credit Card.</strong>',
                content: '',
                complete: false,
                selected: false,
                disabled: false,
                active: false,
                too_early: false,
            },
            {
                id: 2,
                num: '02',
                title: 'Add 1st Southwest Credit Card to Your My10x Wallet',
                short_content:
                    "Once you've opened your 1st Southwest Credit Card, add it to your My10x Wallet.",
                content: '',
                complete: false,
                selected: false,
                disabled: false,
                active: false,
            },
            {
                id: 3,
                num: '03',
                title: 'Wait at least 30 Days',
                short_content:
                    'Some patience is required for this step - sit tight for 30 days before starting your next step.',
                content: '',
                complete: false,
                selected: false,
                disabled: false,
                active: false,
            },
            {
                id: 4,
                num: '04',
                title: 'Open 2nd Southwest Credit Card',
                short_content:
                    'Your next step in earning your Companion Pass will be to <strong>open a second Southwest Credit Card.</strong>',
                content: '',
                complete: false,
                selected: false,
                disabled: false,
                active: false,
            },
            {
                id: 5,
                num: '05',
                title: 'Add 2nd Southwest Credit Card to Your My10x Wallet',
                short_content:
                    "After you've opened your 2nd Southwest Credit Card, add it to your My10x Wallet.",
                content: '',
                complete: false,
                selected: false,
                disabled: false,
                active: false,
            },
            {
                id: 6,
                num: '06',
                title: 'Wait Until 1/1/2026 to Meet Minimum Spends',
                short_content:
                    "Sit back, relax, and whatever you do, <strong>don't meet the minimum spend on either card prior to 1/1/2026</strong>.",
                content: '',
                complete: false,
                selected: false,
                disabled: false,
                active: false,
            },
            {
                id: 7,
                num: '07',
                title: 'Spend Away - Meet Your Minimum Spend on Both Cards Now',
                short_content:
                    "You're free and clear to meet the minimum spends now on both of your Southwest Credit Cards.",
                content: '',
                complete: false,
                selected: false,
                disabled: false,
                active: false,
            },
            {
                id: 8,
                num: '08',
                title: "Congratulations - You've met the criteria to earn your Southwest Companion Pass!",
                short_content:
                    "You've done your part - now you just have to wait for your Companion Pass to post to your Southwest Rapid Rewards account.",
                content: '',
                complete: false,
                selected: false,
                disabled: false,
                active: false,
            },
        ],
    }),
    actions: {
        getPassData() {
            ApiService.apiCall('/companion-pass/user-pass-data', 'get')
                .then((response) => {
                    this.passEnabled = response.data.pass_data.pass_enabled;
                    this.fiveTwentyFourModal =
                        response.data.pass_data.five_twenty_four;
                    this.fiveTwentyFour =
                        response.data.pass_data.five_twenty_four;
                    this.canDismiss524Alert =
                        response.data.pass_data.can_dismiss_524_alert;
                    this.beforeStartDate =
                        response.data.pass_data.before_start_date;
                })
                .catch((response) => {});
        },
        getSteps() {
            ApiService.apiCall('/companion-pass/steps', 'get')
                .then((response) => {
                    this.stepsContent = response.data.steps;
                })
                .catch((response) => {});
        },
        getStep(step) {
            return step in this.completeSteps ? this.completeSteps[step] : null;
        },
        getStepContent(step) {
            return step in this.stepsContent ? this.stepsContent[step] : null;
        },
        setPassEnabled(val) {
            this.passEnabled = val;
        },
        setFiveTwentyFour(val) {
            this.fiveTwentyFourModal = val;
            if (this.canDismiss524Alert) {
                this.fiveTwentyFour = false;
                this.canDismiss524Alert = false;
            }
        },
        togglePass() {
            const data = {
                enable: this.passEnabled,
            };
            ApiService.apiCall('/companion-pass/toggle', 'post', data)
                .then(() => {})
                .catch((response) => {});
        },
        async updateCompleteSteps() {
            return ApiService.apiCall('/companion-pass/completed-steps', 'get')
                .then((response) => {
                    this.completeSteps = response.data.steps;

                    this.steps.forEach((step, i) => {
                        if (step.id in this.completeSteps) {
                            this.steps[i].complete = true;
                            this.steps[i].too_early = this.completeSteps[i + 1]
                                .too_early
                                ? true
                                : false;
                        }
                    });
                    return response;
                })
                .catch((response) => {});
        },
    },
});
